/* 🤖 this file was generated by svg-to-ts */
export const siriusSpeedHigh: {
  name: 'speed_high';
  data: string;
} = {
  name: 'speed_high',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.422 7.05a9 9 0 0 0-3.454-.675C7.003 6.392 3 10.495 3 15.481v2.144h8.359a.75.75 0 0 1 .08-.108l5.4-6.09a.75.75 0 1 1 1.122.996l-4.613 5.202H21v-2.25a9 9 0 0 0-5.578-8.324Zm-3.46-2.175a10.5 10.5 0 0 1 10.538 10.5v2.25a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5v-2.144C1.5 9.69 6.15 4.895 11.963 4.875" fill="currentColor"/></svg>`
};
